
import AppContext from "./Global/Context/appContext";
import React, { useEffect, useState } from 'react'
import reducerApp, { initialStateApp } from "./Global/Reducers/reducerApp";
import { GlobalDebug } from "./remove-console";
import AppRoutes from "./routes/AppRoutes";
import AivoLoader from "./components/Aivo/AivoLoader";


function App() {
   useEffect(() => {

     GlobalDebug(false); 
  }, []);
  return (
    <>      
      
      <AppContext initialStateApp={initialStateApp} reducerApp={reducerApp} >          
        <AppRoutes />   
      </AppContext>
    <AivoLoader />
    </>
  );
}

export default App;
